import React from 'react';
import { CRReviewPage } from './components/CRReviewPage';

/**
 * ReviewCRPage - Main page for reviewing and editing Construction Reviews
 * 
 * This page wraps the CRReviewPage component and provides the interface
 * for users to browse, search, and edit existing construction reviews.
 */
export const ReviewCRPage: React.FC = () => {
  return <CRReviewPage />;
};